import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nav-item" }

import {RouterLink} from "vue-router"

export interface NavigationRouteProps {
  to: string
  name: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NavbarRoute',
  props: {
    to: {},
    name: {}
  },
  setup(__props: any) {

const {to, name} = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createVNode(_unref(RouterLink), {
      class: "nav-link",
      to: _ctx.to
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.name), 1)
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}
}

})